'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectActivePaymentMethod = exports.setActivePaymentMethod = exports.SET_ACTIVE_PAYMENT_METHOD = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.reducer = reducer;

var _PaymentMethodSelector = require('./PaymentMethodSelector.constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SET_ACTIVE_PAYMENT_METHOD = exports.SET_ACTIVE_PAYMENT_METHOD = 'classpass/paymentMethods/SET_ACTIVE_PAYMENT_METHOD';

var setActivePaymentMethod = exports.setActivePaymentMethod = function setActivePaymentMethod(paymentMethodId) {
  return { type: SET_ACTIVE_PAYMENT_METHOD, value: paymentMethodId };
};

var selectPaymentMethods = function selectPaymentMethods(state) {
  return state.features.paymentMethods;
};
var selectActivePaymentMethod = exports.selectActivePaymentMethod = function selectActivePaymentMethod(state) {
  return selectPaymentMethods(state).activePaymentMethodId;
};

var initialState = {
  activePaymentMethodId: _PaymentMethodSelector.DEFAULT_PAYMENT_METHOD_ID
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case SET_ACTIVE_PAYMENT_METHOD:
      return (0, _extends3.default)({}, state, {
        activePaymentMethodId: action.value
      });
    default:
      return state;
  }
}